// removed by extract-text-webpack-plugin
module.exports = {"Brand":"Brand__Brand__3Wsg0","Brand__Title":"Brand__Brand__Title__CVQ1B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Brand/Brand.css
// module id = 133
// module chunks = 0